<script setup lang="ts">
defineProps<{
  /**
   * Below md, let the left slot span the full row instead of hugging its
   * content, and stop its items from growing (they keep their natural width) —
   * so a child with `ml-auto` can push a snug trailing cluster to the right
   * while the first item stays on the left. Off by default so other tables keep
   * their content-width left group.
   */
  leftFullOnMobile?: boolean;
  /**
   * Let the left slot grow to fill the remaining row width (flex-1) and clip
   * its overflow instead of hugging its content. This gives a bounded box a
   * child can measure (scrollWidth vs clientWidth) to decide when to collapse
   * its controls into an overflow menu, rather than relying on a fixed
   * breakpoint. Off by default so other tables keep their content-width group.
   */
  leftGrow?: boolean;
}>();
</script>

<template>
  <div
    class="w-full flex flex-row flex-wrap items-center justify-between gap-2 md:flex-nowrap md:gap-4 p-4"
  >
    <!-- Below md the toolbar can outgrow the row (long entity name + buttons +
         live dot); scroll it horizontally rather than clipping. Children keep
         their size (shrink-0) so there's something to scroll to. -->
    <div
      class="flex justify-start gap-1 max-md:min-w-0 max-md:[&>*]:shrink-0"
      :class="[
        // The 4px of padding, taken back by the margin, is room inside the clip
        // for a count badge that sits up and right of its button, such as
        // Filter's: without it the clip cut the top off the badge.
        leftGrow
          ? 'min-w-0 flex-1 overflow-hidden -my-1 py-1 -mr-1 pr-1'
          : 'w-auto max-md:overflow-x-auto',
        leftFullOnMobile && 'max-md:w-full max-md:[&>*]:flex-none',
      ]"
    >
      <slot name="left"></slot>
    </div>
    <div class="w-auto flex justify-center gap-1">
      <slot name="center"></slot>
    </div>
    <div class="w-full flex justify-between gap-1 md:w-auto md:justify-end">
      <slot name="right"></slot>
    </div>
  </div>
</template>
